import { z } from 'zod';

export const trancheModelSchema = z.object({
  expiryDate: z.string(),
  balance: z.number(),
});
